// extracted by mini-css-extract-plugin
module.exports = {"festivalReferral":"styles_festivalReferral__2CcBW","receive":"styles_receive__2Jwra"};